export const environment = {
  production: false,
  apiBaseUrl: "https://devsuperadmin.servicegalaxy.com:3000/",
  //apiBaseUrl: "https://stagingsuperadmin.servicegalaxy.com:3000/",
  zoomOauthRedirectURI: 'https://zoom.us/oauth/authorize?response_type=code&client_id=pQu905JvTIORykAIV8HcPw&redirect_uri=https://superadmin.servicegalaxy.com/%23/coaching/meeting-list',
  takePaymentLink: 'https://securelink-prod.valorpaytech.com:4430/?redirect=1&uid=85c64553-7108-11ef-a80f-02848a808807',
  valorWebHook: 'https://stagingsuperadmin.servicegalaxy.com/v1/client/valorWebhook',
  bucketurl: 'https://service-galaxy-dev.s3.us-east-2.amazonaws.com',
  bucketname: "service-galaxy-dev",
  googleMapsApiKey: "AIzaSyC2UyybrDbece03B9gLCOc1mFlRIrG7bgk",
  meetingConfig: {
    sdkKey: 'ikI41GHPAriAjMHhDEx9iRYmTeBrWv7UsGGa',
    CLIENT_ID: 'pQu905JvTIORykAIV8HcPw',
    CLIENT_SECRET: '5QLihzRoykfPg4AVKtpykR17hcVKxOdS'
  },
  baseUrl: 'https://devadmin.servicegalaxy.com/login/',
  calKEY: '0285120952-fcs-1681488481',
  googleKey: "AIzaSyC2UyybrDbece03B9gLCOc1mFlRIrG7bgk",
  firebase: {
    apiKey: "AIzaSyBPLQzzcxnw4qKYV7WmkCKSy6AnnF3gMIk",
    authDomain: "service-galaxy.firebaseapp.com",
    databaseURL: "https://service-galaxy-default-rtdb.firebaseio.com",
    projectId: "service-galaxy",
    storageBucket: "service-galaxy.firebasestorage.app",
    messagingSenderId: "466475764062",
    appId: "1:466475764062:web:73dc8cc4354c54dd9467cf",
    measurementId: "G-JVZL9QCTSJ"
  },
};
